module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_oslo_viken_pos.f6592727.png";